import React, { useContext } from "react"
import * as styles from "./styles.module.scss"
import { HomeContext } from "../../hooks/HomeContext"
import SecondaryButton from '../secondary-button-clear'
import PrimaryButton from '../primary-button'

const ReadyForE2E = ({ to }) => {
  const { readyForEndToEnd } = useContext(HomeContext)

  const shouldRenderRightButton = typeof window !== "undefined" && window.location.pathname !== "/mvp-blueprint";

  const rightButton = shouldRenderRightButton && (
    <SecondaryButton to={readyForEndToEnd.rightButton.to}>
      {readyForEndToEnd.rightButton.text}
    </SecondaryButton>
  );

  return (
    <div className={styles.wrapper}>
      <h2>{readyForEndToEnd.title}</h2>
      <div className={styles.buttonsWrapper}>
        <PrimaryButton to={readyForEndToEnd.leftButton.to}>
          {readyForEndToEnd.leftButton.text}
        </PrimaryButton>
        {rightButton}
      </div>
    </div>
  );
}

export default ReadyForE2E
